import React from 'react';
import ReactDOM from 'react-dom/client';
import GetData from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <GetData></GetData>
);


